import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

let initialState = {
  product: {
    name: "",
    categoryId: "",
    variants: [],
    attributes: [],
    selectedAttributs: [],
    priceDetails: [],
    price: 0,
    desc: "",
    catalogue: "",
    demoVideo: "",
    sizeRef: "",
    howToOrderLabel: "",
    sizeRefLabel: "",
    catalogueLabel: "",
    webPrice: 0,
    inputs: [],
    images: [],
    courierType: "individual",
    courierAmount: 0,
  },
};

export const productReducer = createSlice({
  name: "product",
  initialState,
  reducers: {
    update: (state, action) => {
      state.product = { ...state.product, ...action.payload };
      if (
        action.payload.variants &&
        state.product.selectedAttributs.length > 0
      ) {
        state.product.selectedAttributs =
          state.product.selectedAttributs.filter((obj) => {
            if (action.payload.variants.includes(obj.id)) {
              return obj;
            }
          });
      }
    },
    attributes: (state, action) => {
      if (state.product.selectedAttributs.length > 0) {
        let variantsDetails = _.keyBy(state.product.selectedAttributs, "id");
        if (variantsDetails[action.payload.id]) {
          variantsDetails[action.payload.id].count =
            action.payload.value.length;
          variantsDetails[action.payload.id].value = action.payload.value;
          variantsDetails[action.payload.id].name = action.payload.name;
        } else {
          state.product.selectedAttributs.push({
            id: action.payload.id,
            name: action.payload.name,
            value: action.payload.value,
            count: action.payload.value.length,
          });
        }
      } else {
        state.product.selectedAttributs.push({
          id: action.payload.id,
          name: action.payload.name,
          value: action.payload.value,
          count: action.payload.value.length,
        });
      }
    },
    destore: (state, action) => {
      state.product = initialState.product;
    },
  },
});

// Action creators are generated for each case reducer function
export const { update, attributes, destore } = productReducer.actions;

export default productReducer.reducer;
